import { Key } from '../constants';
export const createMakerDepositFirstPart = () => [Key.MAKER_DEPOSIT];
export const createPaymentActionFirstPart = (user) => [Key.PAYMENT_ACTION, user];
export const createMakerDepositKey = (user) => ({
    first_part: createMakerDepositFirstPart(),
    second_part: [user],
});
export const createPaymentActionKey = ({ user, actionId, blockHeight, executionStep, }) => ({
    first_part: createPaymentActionFirstPart(user),
    second_part: [blockHeight, executionStep, actionId],
});
